// Crawlers/analyzers get content fully visible on first paint (no entrance animations).
export const IS_BOT =
  typeof navigator !== "undefined" &&
  (navigator.webdriver === true ||
    /bot|crawl|spider|slurp|headless|lighthouse|pagespeed|gtmetrix|google|bing|yandex|baidu|duckduck|facebookexternalhit|semrush|ahrefs|ionos|seobility|sistrix|seositecheckup|python|curl|wget|phantom|prerender/i.test(navigator.userAgent || ""));
